import { StationsList } from "../data/MenuData";

export default function RaportQuery({ query, setQuery }) {

    function formData(date) {
        const data = new Date(date);
        const hours = String(data.getHours()).padStart(2, '0');
        const minutes = String(data.getMinutes()).padStart(2, '0');
        const day = String(data.getDate()).padStart(2, '0');
        const month = String(data.getMonth() + 1).padStart(2, '0');
        const year = data.getFullYear();
        return `${year}-${month}-${day}T${hours}:${minutes}`;
    };
    
    function submitForm(e) {
        e.preventDefault();
        const station = JSON.parse(e.target[0].value);
        setQuery({
            station,
            dateFrom: new Date(e.target[1].value),
            dateTo: new Date(e.target[2].value),
        });
    };

    return (
        <form onSubmit={submitForm}>
            <label>
                <p>Stacja</p>
                <select
                    id="station"
                    defaultValue={JSON.stringify([query.station])}
                >
                    <option value="" disabled>-- Wybierz stację --</option>
                    {StationsList.map(s => (
                        <option key={s.code} value={JSON.stringify([s.code])}>{s.name}</option>
                    ))}
                </select>
            </label>
            <label>
                <p>Data od</p>
                <input
                    type="datetime-local"
                    id="dateFrom"
                    defaultValue={formData(query.dateFrom)}
                />
            </label>
            <label>
                <p>Data do</p>
                <input
                    type="datetime-local"
                    id="dateTo"
                    defaultValue={formData(query.dateTo)}
                />
            </label>
            <input type="submit" value="Stwórz raport"/>
        </form>
    )
}